import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, inject, input, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ICON } from '../../constants/icons.constant';
import { BaseComponent } from '../base/base.component';
import { ImageComponent } from '../image/image.component';
import { MenuAction } from '../menu/menu-action.types';
import { MenuHeaderDirective } from '../menu/menu-header.directive';
import { MenuComponent } from '../menu/menu.component';
import { Router } from '@angular/router';
import { CURRENT_USER } from '../../tokens/current-user.token';
import { AUTHENTICATION } from '../../tokens/authentication.token';

/** The actions a user can select from the profile menu. */
export type ProfileMenuAction = 'profile' | 'onboarding' | 'logout';

@Component({
  selector: 'immo-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.css'],
  imports: [MenuComponent, MenuHeaderDirective, ImageComponent, MatIconModule],
})
export class ProfileMenuComponent extends BaseComponent {
  // -----------------------------------------------------------------------------------------------------
  // @ DEPENDENCIES
  // -----------------------------------------------------------------------------------------------------

  private readonly router = inject(Router);

  protected readonly user = inject(CURRENT_USER);

  private readonly authentication = inject(AUTHENTICATION);

  // -----------------------------------------------------------------------------------------------------
  // @ INSTANCE VARIABLES
  // -----------------------------------------------------------------------------------------------------

  readonly profileActions = signal<MenuAction<ProfileMenuAction>[]>([
    { value: 'profile', label: 'Mein Profil', icon: ICON.userCircle },
    { value: 'onboarding', label: 'Onboarding erneut ansehen', icon: ICON.arrowCounterClockwise },
    {
      value: 'logout',
      label: 'Abmelden',
      icon: ICON.signOut,
      class: 'danger',
      separatorBefore: true,
    },
  ]);

  // -----------------------------------------------------------------------------------------------------
  // @ INPUT VARIABLES
  // -----------------------------------------------------------------------------------------------------

  readonly avatarUrl = input<string | undefined>(undefined);

  /** Passed through to the menu trigger — hosts style the whole clickable row. */
  readonly triggerClass = input<string>('size-[40px]');

  /** Overlay positions — the sidebar footer opens UPWARDS so the panel stays in view. */
  readonly positions = input<ConnectedPosition[]>([
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 },
    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetY: -8 },
  ]);

  // -----------------------------------------------------------------------------------------------------
  // @ PUBLIC METHODS
  // -----------------------------------------------------------------------------------------------------

  /**
   * Handles the selected profile menu action.
   *
   * @param action - The selected action.
   * @returns {void}
   */
  onAction(action: ProfileMenuAction): void {
    switch (action) {
      case 'profile': {
        this.router.navigate(['/user/profile']);
        break;
      }
      case 'onboarding': {
        // restart onboarding
        break;
      }
      case 'logout': {
        this.authentication.logout();
        break;
      }
    }
  }
}
